import Grid from "@mui/material/Grid2";
import {Stack, useMediaQuery} from "@mui/material";
import TitleMenu from "components/TitleMenu";
import CategoryList from "pages/Material/components/CategoryList";
import React, {useEffect, useMemo, useState} from "react";
import {Outlet, useParams} from "react-router-dom";
import {
  useKeywordsQuery,
  useMaterialsQuery,
} from "@generated/graphql";
import {Category, FilterItem} from "pages/Material/types";
import ContentContainer from "components/ContentContainer";
import {debounce} from "lodash";
import CategoryListModal from "pages/Material/components/CategoryList/CategoryListModal";
import MaterialFilters from "pages/Material/list/components/MaterialFilters";
import useMaterialType from "pages/Material/useMaterialType";

const MaterialContainer = () => {
  const type = useMaterialType();

  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'))

  const {id} = useParams()

  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState<string>("");
  const [keywordsFilter, setKeywordsFilter] = useState<string[]>([]);
  const [searchInput, setSearchInput] = useState<string>("");
  const [debouncedSearchInput, setDebouncedSearchInput] = useState<string>("");
  const [selectedKeywords, setSelectedKeywords] = useState<string[]>([]);
  const [mixedFilterValue, setMixedFilterValue] = useState<FilterItem | null>(null);

  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearchInput(searchInput);
    }, 300);

    handler();

    return () => {
      handler.cancel();
    };
  }, [searchInput]);

  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  const {data: keywords, loading: loadingKeywords} = useKeywordsQuery({
    variables: {
      filter: {},
      pagination: {page: 0, limit: 100}
    },
    skip: !!id
  });
  const keywordList = keywords?.keywords?.data;

  const {data: materials, loading: loadingMaterials} = useMaterialsQuery({
    variables: {
      filter: {
        type,
        subcategoriesIds: selectedSubcategory ? [selectedSubcategory] : undefined,
        keywordsIds: keywordsFilter,
        search: debouncedSearchInput || undefined,
      },
      pagination: {page: page - 1, limit}
    },
    skip: !!id
  })
  const materialList = materials?.materials;

  useEffect(() => {
    setSelectedCategory(null);
    setSelectedSubcategory('');
    setMixedFilterValue(null);
    setSelectedKeywords([]);
    setKeywordsFilter([]);
  }, [type]);

  const value = useMemo(() => ({
    // loadingSubcategories,
    loadingKeywords, loadingMaterials,
    materialList,
    // subcategoryList,
    keywordList,
    selectedCategory,
    setSelectedCategory,
    setSelectedSubcategory,
    page,
    limit,
    setLimit,
    setPage,
    searchInput,
    setSearchInput,
    setKeywordsFilter,
    selectedKeywords,
    setSelectedKeywords,
    mixedFilterValue,
    setMixedFilterValue
  }), [
    // loadingSubcategories,
    loadingKeywords, loadingMaterials,
    materialList,
    // subcategoryList,
    keywordList,
    selectedCategory,
    setSelectedCategory,
    setSelectedSubcategory,
    page,
    limit,
    setLimit,
    setPage,
    searchInput,
    setSearchInput,
    setKeywordsFilter,
    selectedKeywords,
    setSelectedKeywords,
    mixedFilterValue,
    setMixedFilterValue
  ]);


  return (
    <ContentContainer>
      <Grid container columnSpacing={1}>
        <Grid size={{xxs: 12, xl: 3}}>
          {
            isDesktop ? (
              <Stack spacing={3} mb={5}>
                <TitleMenu>
                  Категории
                </TitleMenu>
                <CategoryList
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  selectedSubcategory={selectedSubcategory}
                  setSelectedSubcategory={setSelectedSubcategory}
                />
              </Stack>
            ) : (
              <CategoryListModal selectedCategory={selectedCategory}
                                 setSelectedCategory={setSelectedCategory}
                                 selectedSubcategory={selectedSubcategory}
                                 setSelectedSubcategory={setSelectedSubcategory}/>
            )
          }
          {
            isDesktop && !id && (
              <MaterialFilters
                selectedKeywords={selectedKeywords}
                setSelectedKeywords={setSelectedKeywords}
                mixedFilterValue={mixedFilterValue}
                setMixedFilterValue={setMixedFilterValue}
                keywordList={keywordList}
                setKeywordsFilter={setKeywordsFilter}
                setSelectedSubcategory={setSelectedSubcategory}
                setSelectedCategory={setSelectedCategory}
              />
            )
          }
        </Grid>
        <Grid size={{xs: 12, xl: 9}}>
          <Stack spacing={5}>
            <Outlet context={value}/>
          </Stack>
        </Grid>
      </Grid>
    </ContentContainer>
  )
}

export default MaterialContainer;
